'use strict';

import 'fancybox'
import '../../_assets/abbott/js/_modernizr';
import Loader from '../loader/loader';
import { toaster } from '../../_assets/abbott/js/_material';

export default class TableWorkplace {
    constructor() {
        if ($('.workspace').length) {
            let $filter = $("#FilterWorkplaces .filter-dropdown--item"),
                isMobileDevice = Modernizr.mq('(max-width: 767px)'),
                loader = new Loader(),
                dataParams = {};

            $('.workspace__header').on('click', function (e) {
                let $this = $(this),
                    $detail = $this.next();

                $this.toggleClass('active');
                $detail.slideToggle({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
            });

            $filter.on('click', function (e){
                e.preventDefault();

                let $this = $(this),
                    filterBy = $this.text().toLowerCase();

                if(filterBy === 'all'){
                    $('.workspace').show();
                    return false;
                }

                $('.workspace').each(function (){
                    var status = $(this).find('.Status').val();

                    if(status.toLowerCase() == filterBy){
                        $(this).show();
                    }else{
                        $(this).hide();
                    }
                });
                
            })
        }
    }
}
